module.exports = __webpack_public_path__ + "static/2019-tattoo-4-8d76fa2ed535a9e6271f9f438067f8e8.jpg";